import { render } from "./PanelTab.vue?vue&type=template&id=54fa3907&scoped=true"
import script from "./PanelTab.vue?vue&type=script&lang=js"
export * from "./PanelTab.vue?vue&type=script&lang=js"

import "./PanelTab.vue?vue&type=style&index=0&id=54fa3907&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54fa3907"]])

export default __exports__